import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { RowLabelAndNumbers, RowTeamGoalsWithJerseys, TeamsJerseys } from '../../../components';
import { useStatsData } from '../../../hooks';
import toFixedOrInteger from '../../../utils/toFixedOrInteger';
import { ApiWidgetType, StatsTypes } from '../../../constants';

const rowHeightClassName = 'h-[40px]';
const columnWidthClassName = 'w-[54px]';

const Goals = () => {
  const translate = useNewTranslations();
  const { teams, widget } = useStatsData({
    widgetType: StatsTypes.GOALS,
  });

  if (!widget || widget.type !== ApiWidgetType.GOALS || !widget?.data) {
    return null;
  }

  const { home: homeStats, away: awayStats } = widget.data;

  return (
    <Section name={translate('PreMatchStats.Goals')} contentClassName="flex flex-col gap-2">
      <TeamsJerseys
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
        homeTeamName={teams.home.name}
        awayTeamName={teams.away.name}
      />
      <RowTeamGoalsWithJerseys
        homeNumber={homeStats.totalGoals}
        awayNumber={awayStats.totalGoals}
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
      />
      <RowLabelAndNumbers
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.ScoredGame')}
        homeNumber={toFixedOrInteger(homeStats.goalsScored, 1)}
        awayNumber={toFixedOrInteger(awayStats.goalsScored, 1)}
      />
      <RowLabelAndNumbers
        className={rowHeightClassName}
        numberColumnClassName={columnWidthClassName}
        label={translate('PreMatchStats.ConcededGame')}
        homeNumber={toFixedOrInteger(homeStats.goalsConceded, 1)}
        awayNumber={toFixedOrInteger(awayStats.goalsConceded, 1)}
      />
    </Section>
  );
};

export default Goals;
